// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/es6.number.epsilon.js